module.exports = "<div ui-view class=\"fade\"></div>\n<div vc-recaptcha\n    class=\"captcha2\"\n    key=\"Recaptcha.captchaKey\"\n    on-create=\"Recaptcha.setWidgetId(widgetId)\"\n    on-success=\"setCaptchaResponse(response)\"\n    size=\"invisible\">\n</div>"


//////////////////
// WEBPACK FOOTER
// ./scripts/common/controllers/auth/baseAuth.html
// module id = 9wlN
// module chunks = 0